import { DebugLogEntry } from './types'
let globalLogs: DebugLogEntry[] = []
let maxLogs = 100
export const DEBUG_LOG_EVENT = 'debug_console_log_added'
export const DEBUG_LOG_CLEAR_EVENT = 'debug_console_log_cleared'
export function setMaxLogs(max: number) {
  maxLogs = max
}

/**
 * Push a log from anywhere in the app (outside React components too)
 */
export function pushDebugLog(entry: Omit<DebugLogEntry, 'id' | 'timestamp'>) {
  const newLog: DebugLogEntry = {
    ...entry,
    id: Math.random().toString(36).substring(2, 9),
    timestamp: new Date().toISOString(),
  }
  globalLogs = [newLog, ...globalLogs].slice(0, maxLogs)

  // Dispatch event so hooks can update
  if (typeof window !== 'undefined') {
    window.dispatchEvent(
      new CustomEvent(DEBUG_LOG_EVENT, {
        detail: newLog,
      }),
    )
  }
  return newLog
}

/**
 * Clear all logs
 */
export function clearDebugLogs() {
  globalLogs = []
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(DEBUG_LOG_CLEAR_EVENT))
  }
}

/**
 * Get current logs
 */
export function getDebugLogs() {
  return globalLogs
}
